import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { RealisationCard, Lightbox } from "@/components/Galerie";
import { api } from "@/lib/api";
import { useLocale } from "@/context/LocaleContext";

export const HomeRealisations = () => {
  const { t } = useLocale();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const [idx, setIdx] = useState(0);
  useEffect(() => { api.realisations({ accueil: true }).then((r) => setItems(r.slice(0, 6))).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32 border-t border-sand-dark" data-testid="home-realisations">
      <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-14">
        <div>
          <p className="eyebrow mb-6">{t("Tambours réalisés")}</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-bark leading-tight max-w-2xl">{t("Nés ici, entre des mains différentes.")}</h2>
          <p className="text-fumee mt-5 max-w-xl leading-relaxed">{t("Quelques tambours créés à l'atelier ou en stage — pour imaginer le vôtre, puis le pratiquer.")}</p>
        </div>
        <Link to="/tambours-realises" data-testid="home-realisations-link" className="group inline-flex items-center gap-3 text-terra text-sm tracking-wide">{t("Voir les tambours réalisés")} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" /></Link>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-8">
        {items.map((r, i) => <RealisationCard key={r.id} r={r} index={i} compact onOpen={(item, k) => { setOpen(item); setIdx(k); }} />)}
      </div>
      <Lightbox item={open} index={idx} onClose={() => setOpen(null)} onIndex={setIdx} />
    </section>
  );
};
